<template>
  <div class="container">
    <div class="find-counselor-wrap-main" id="true"></div>
  </div>
</template>

<script>
import { insertJs } from '@/utils/dynamicLoadScript'
export default {
  name: 'FindCounselor',
  mounted() {
    setTimeout(() => {
      insertJs('script', ['https://form.jotform.com/jsform/201808569880062?appendTo=true&formId=true'])
    }, 1000)
  }
}
</script>
